'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { defaultUser } from '@haaretz/s-consts';
import useOnce from '@haaretz/s-use-once';
import createUser from '@haaretz/s-user-utils/createUser';
import Script from 'next/script';
import React from 'react';
const initialUser = {
    ...defaultUser
};
const UserContext = /*#__PURE__*/ React.createContext(undefined);
const UserSetter = /*#__PURE__*/ React.createContext(undefined);
export function UserProvider({ children, value, sbOverrideValue }) {
    const [user, setUser] = React.useState(// istanbul ignore next
    typeof window === 'undefined' ? value ?? initialUser : sbOverrideValue || createUser(document.cookie, true));
    const userSetter = React.useCallback((action, cb)=>{
        if (action === 'logout') {
            setUser(initialUser);
        } else if (action === 'login') {
            const clientUser = createUser(document.cookie, true);
            const isLoggedIn = !!clientUser.userMail || !!clientUser.university;
            setUser({
                ...clientUser,
                isLoggedIn
            });
        } else {
            console.error(`Invalid user action: ${action}`);
            return;
        }
        cb?.();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Script, {
                id: "htz-user",
                children: `
          window.__HTZ = window.__HTZ || {};

          window.__HTZ.userType = "${user.userType}";
    `
            }),
            /*#__PURE__*/ _jsx(UserContext, {
                value: user,
                children: /*#__PURE__*/ _jsx(UserSetter, {
                    value: userSetter,
                    children: children
                })
            })
        ]
    });
}
export function userDispenserFactory(cookie) {
    const newUser = createUser(cookie, true);
    const user = {
        ...newUser,
        isLoggedIn: !!newUser.userMail || !!newUser.university
    };
    return user;
}
/**
 *
 * @param startFrom -
 *   * Should be set to `cookieValue` when `userType` has an effect on the
 *     initial render of a component, in order to prevent hydration mismatches.
 *   * Should be set to `serverValue` when the value of `userType` is only used
 *     after an effect or inside an event handler.
 *
 */ export default function useUser(startFrom) {
    const context = React.use(UserContext);
    const [updatedStartFrom, setUpdatedStartFrom] = React.useState(startFrom);
    useOnce(()=>{
        setUpdatedStartFrom('cookieValue');
    }, startFrom === 'serverValue');
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    if (updatedStartFrom === 'serverValue') {
        return defaultUser;
    }
    return context;
}
export function useSetUser() {
    const context = React.use(UserSetter);
    if (context === undefined) {
        throw new Error('useSetUser must be used within a UserProvider');
    }
    return context;
}
export function useUserAtom(startFrom) {
    return [
        useUser(startFrom),
        useSetUser()
    ];
}

//# sourceMappingURL=userAtom.js.map